import { i18n as i18nFn, I18n as I18nReact } from "@lookiero/i18n-react";
import { EndpointFunction, fetchTranslations, translationEndpoints } from "@lookiero/sty-psp-i18n";
import { Tradename } from "@lookiero/sty-sp-tradename";

const DOMAIN = "StyleProfileI18n";

const DATE_FORMAT_PREFIX = "date_format.";
const PREFIX = "style_profile.";

enum I18nMessages {
  HEADER_TITLE = "header.title",
  HOME_TITLE = "main_page.title",
  HOME_DESCRIPTION = "main_page.subtitle",
  SOCIAL_SUBTITLE = "social.subtitle",
  IMAGE_PICKER_MODAL_TITLE = "image_picker_modal.title",
  IMAGE_PICKER_MODAL_TAKE_PHOTO_BUTTON = "image_picker_modal.take_photo_button",
  IMAGE_PICKER_MODAL_CHOOSE_FROM_LIBRARY_BUTTON = "image_picker_modal.choose_from_library_button",
  UPLOAD_IMAGE_TOAST_GENERIC_ERROR = "upload_image.toast.generic_error",
  SAVE_CONFIRMATION_TOAST = "save_confirmation.toast",
  TOAST_GENERIC_ERROR = "toast.generic.error",
  NEXT_BEST_ACTION_TITLE = "next_best_action.title",
  NEXT_BEST_ACTION_SUCCESS_TITLE = "next_best_action.success_title",
  NEXT_BEST_ACTION_SUCCESS_DESCRIPTION = "next_best_action.success_description",
  NEXT_BEST_ACTION_SUCCESS_CTA = "next_best_action.success_cta",
  ANDROID_IN_APP_BROWSER_UPLOAD_HELPER_TEXT = "android_in_app_browser_upload_helper_text",
}

const cache = new Map<Tradename, I18nReact>();

interface I18nFunctionArgs {
  readonly tradename: Tradename;
}

interface I18nFunction {
  (args: I18nFunctionArgs): I18nReact;
}

const i18n: I18nFunction = ({ tradename }) => {
  if (cache.has(tradename)) {
    return cache.get(tradename)!;
  }

  const translations: EndpointFunction[] = [
    (locale) =>
      translationEndpoints({
        projects: ["style-profile", "look-and-like"],
        tradename,
      })(locale),
  ];

  const component = i18nFn({
    fetchTranslation: fetchTranslations({ translations }),
    domain: DOMAIN,
  });

  cache.set(tradename, component);
  return component;
};

export { DOMAIN, I18nMessages, DATE_FORMAT_PREFIX, PREFIX, i18n };
